module.exports = __webpack_public_path__ + "static/media/docc_dark.55beac1e.svg";